import ClientWebservice from './ClientWebService';
import { blumarWebserviceAxios } from './HttpHelper';

let axios = blumarWebserviceAxios();


export default class HotelPriceService extends ClientWebservice{
	constructor() {
		super('/hotels');
	}

	list(criteria, {login, key} = {}) {
		let auth = { username: login, password: key };
		return axios.get(this.url + '/prices', {auth, params: criteria});
	}
}



// WEBPACK FOOTER //
// ./src/services/HotelPricesService.js